import common from "./common";
import apps from "./apps";
import errors from "./errors";
import organizations from "./organizations";
import resellers from "./resellers";
import users from "./users";
import roles from "./roles";
import permissions from "./permissions";
import products from "./products";
import resellerInvoices from "./resellerInvoices";
import resellerPayments from "./resellerPayments";
import resellerProduct from "./resellerProduct";
import resellerServices from "./resellerServices";
import invoices from "./invoices";
import customers from "./customers";
import packages from "./packages";
import subscriptions from "./subscriptions";
import payments from "./payments";
import profile from "./profile";
import contacts from "./contacts";
import dpaPpa from "./dpaPpa";
import esigns from "./esigns";
import suppliers from "./suppliers";
import locations from "./locations";
import files from "./files";
import notifications from "./notifications";
import purchasesOrders from "./purchasesOrders";
import purchasesInvoices from "./purchasesInvoices";
import purchasesDeliveries from "./purchasesDeliveries";
import purchasesPayments from "./purchasesPayments";
import salesOrders from "./salesOrders";
import salesInvoices from "./salesInvoices";
import salesDeliveries from "./salesDeliveries";
import salesPayments from "./salesPayments";
import warehouses from "./warehouses";
import stockMovements from "./stockMovements";
import imports from "./imports";
import properties from "./properties";
import propertyTransactions from "./propertyTransactions";
import auctions from "./auctions";
import bids from "./bids";
import wallet from "./wallet";
import contracts from "./contracts";
import signatures from "./signatures";
import syncLogs from "./syncLogs";
import thirdPartyServices from "./thirdPartyServices";
import templatesMail from "./templateMails";
import mailV2 from "./mailV2";
import nuveiCards from "./nuveiCards";
import elixioPay from "./elixioPay";
import taxes from "./taxes";
export default {
  COMMON: common,
  APPS: apps,
  ERRORS: errors,
  USERS: users,
  ORGANIZATIONS: organizations,
  RESELLERS: resellers,
  ROLES: roles,
  PERMISSIONS: permissions,
  PRODUCTS: products,
  INVOICES: invoices,
  CUSTOMERS: customers,
  SUBSCRIPTIONS: subscriptions,
  PACKAGES: packages,
  PAYMENTS: payments,
  PROFILE: profile,
  CONTACTS: contacts,
  DPA_PPA: dpaPpa,
  ESIGNS: esigns,
  SUPPLIERS: suppliers,
  LOCATIONS: locations,
  FILES: files,
  NOTIFICATIONS: notifications,
  PURCHASES_ORDERS: purchasesOrders,
  PURCHASES_INVOICES: purchasesInvoices,
  PURCHASES_DELIVERIES: purchasesDeliveries,
  PURCHASES_PAYMENTS: purchasesPayments,
  SALES_ORDERS: salesOrders,
  SALES_INVOICES: salesInvoices,
  SALES_DELIVERIES: salesDeliveries,
  SALES_PAYMENTS: salesPayments,
  RESELLER_PRODUCTS: resellerProduct,
  RESELLER_SERVICES: resellerServices,
  RESELLER_INVOICES: resellerInvoices,
  RESELLER_PAYMENTS: resellerPayments,
  WAREHOUSES: warehouses,
  STOCK_MOVEMENTS: stockMovements,
  IMPORTS: imports,
  PROPERTIES: properties,
  AUCTIONS: auctions,
  BIDS: bids,
  PROPERTY_TRANSACTIONS: propertyTransactions,
  WALLET: wallet,
  CONTRACTS: contracts,
  SIGNATURES: signatures,
  SYNC_LOGS: syncLogs,
  THIRD_PARTY_SERVICES: thirdPartyServices,
  TEMPLATES_MAILS: templatesMail,
  MAIL_V2: mailV2,
  NUVEI_CARDS: nuveiCards,
  ELIXIOPAY: elixioPay,
  TAXES: taxes,
};
